var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"field__content"},[(!_vm.readonly)?[_c('a-input',{attrs:{"type":"number"},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}}),_c('div',{staticClass:"ant-form-extra"},[_vm._v("库存量为总库存数量")])]:[_c('div',[_vm._v(" "+_vm._s(_vm.val)+" ")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }